<script setup>
import SelectionButtonsInput from "@/components/forms/SelectionButtonsInput.vue";
import SelectionButton from "@/components/forms/SelectionButton.vue";
import {Priority, PriorityLabel} from "@/components/hpo/choices";
import {pgettext} from "@/utils/translate";

const priority = defineModel({type: String});
const props = defineProps({
    fieldProps: {
        type: Object,
    },
    title: {
        type: String,
        required: true
    },
});
const emit = defineEmits(['submit']);

function submit() {
    emit('submit', priority.value);
}
</script>

<template>
    <main>
        <h1>{{ title }}</h1>

        <SelectionButtonsInput v-model="priority" v-bind="fieldProps" size="x-large" :height="72" @select="submit()">
            <SelectionButton :value="Priority.I" color="red">
                <strong>{{ PriorityLabel[Priority.I] }}</strong>
            </SelectionButton>

            <SelectionButton :value="Priority.II" color="yellow-darken-3">
                <strong>{{ PriorityLabel[Priority.II] }}</strong>
            </SelectionButton>

            <SelectionButton :value="Priority.III" color="green">
                <strong>{{ PriorityLabel[Priority.III] }}</strong>
            </SelectionButton>

            <SelectionButton :value="Priority.IV" color="black">
                <strong>{{ PriorityLabel[Priority.IV] }}</strong>
            </SelectionButton>
        </SelectionButtonsInput>

        <p v-if="priority" class="text-center mt-4">
            <v-btn color="green" size="large" @click="submit()">
                <strong>{{ pgettext('action', 'Continue') }}</strong>
            </v-btn>
        </p>
        <p v-else class="text-center text-subtitle-2">
            {{ gettext('To continue, please select one of the options.') }}
        </p>
    </main>
</template>
